import { render, staticRenderFns } from "./PaymentPendingBanner.vue?vue&type=template&id=4ac69eda"
import script from "./PaymentPendingBanner.vue?vue&type=script&lang=js"
export * from "./PaymentPendingBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports